import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { UnorderedBulletGroup } from "../../../components/unordered-bullet-group";
import { MethodOverview } from "../../../components/method-overview";
import Expert from "../../../images/expert-interviews.png";
import LitReview from "../../../images/lit-review.png";

export interface IBackgroundProps {
    sectionId: string;
    index: number;
}

export function Background(props: IBackgroundProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Inception`}
                altText="The team putting sticky notes on a window"
            />
            <ParagraphGroup
                body={[
                    "To orient ourselves in the complex and interconnected problem space of misinformation, we broke our research into three areas:"
                ]}
            />
            <UnorderedBulletGroup
                bullets={
                    [
                        "Human evaluation and consumption of information",
                        "News and information cycle",
                        "Social platforms and AI"
                    ]
                }
            />
            <ParagraphGroup
                body={
                    [
                        "We started with expert interviews and an extensive review of existing research to build a foundational understanding around these themes."
                    ]
                }
            />
            <MethodOverview
                methods={
                    [
                        {
                            title: "Expert Interviews",
                            body: "Our team interviewed experts to understand the social, psychological, and technological factors around the creation, consumption, and spread of misinformation.",
                            imgSrc: Expert,
                            altText: "Expert interview icon"
                            
                        },
                        {
                            title: "Literature reviews",
                            body: "We reviewed papers related to misinformation, AI systems for misinformation detection, and user attitudes toward AI.",
                            imgSrc: LitReview,
                            altText: "Literature Review icon"
                        }
                    ]
                }
            />
            <ParagraphGroup
                body={
                    [
                        "Our research uncovered the following contributors to the problem we face today:"
                    ]
                }
            />
            <UnorderedBulletGroup
                bullets={
                    [
                        "Public dissemination of information on social platforms is faster and easier than ever before.",
                        "Disinformation takes advantage of human psychological factors that leave people vulnerable to deception.",
                        "Social platforms have no incentive and historically faced no pressure to track and manage misinformation.",
                    ]
                }
            />
            <ParagraphGroup
                body={
                    [
                        "This initial research stage established how current practices fuel the flames of the problem, but misinformation cannot thrive without an audience, therefore, we needed to talk directly to users to make sense of how the problem reached its current scale."
                    ]
                }
            />
        </Section>
    );
}